import React from "react";

const Duas = () => {
  const duaList = [
    {
      title: "دعائے انس بن مالک",
      subtitle: "ہر آفت سے بچاؤ کی دعا (حفاظتی قلعہ)",
      arabic: `بِسْمِ اللّٰهِ وَ بِاللّٰهِ، بِسْمِ اللّٰهِ خَيْرِ الْاَسْمَاءِ، بِسْمِ اللّٰهِ الَّذِىْ لَا يَضُرُّ مَعَ اسْمِهٖ شَیْءٌ فِی الْاَرْضِ وَلَا فِی السَّمَاءِ. بِسْمِ اللّٰهِ افْتَتَحْتُ وَ بِاللّٰهِ خَتَمْتُ وَ بِهٖ اٰمَنْتُ، بِسْمِ اللّٰهِ اَصْبَحْتُ وَ عَلَی اللّٰهِ تَوَكَّلْتُ، بِسْمِ اللّٰهِ عَلٰى قَلْبِىْ وَ نَفْسِىْ، بِسْمِ اللّٰهِ عَلٰى عَقْلِىْ وَ ذِهْنِىْ، بِسْمِ اللّٰهِ عَلٰى اَهْلِىْ وَ مَالِىْ، بِسْمِ اللّٰهِ عَلٰى مَا اَعْطَانِىْ رَبِّىْ، بِسْمِ اللّٰهِ الشَّافِىْ، بِسْمِ اللّٰهِ الْمُعَافِىْ، بِسْمِ اللّٰهِ الْوَافِىْ، بِسْمِ اللّٰهِ الَّذِىْ لَا يَضُرُّ مَعَ اسْمِهٖ شَیْءٌ فِی الْاَرْضِ وَلَا فِی السَّمَاءِ وَ هُوَ السَّمِيْعُ الْعَلِيْمُ، هُوَ اللّٰهُ اَللّٰهُ رَبِّىْ لَا اُشْرِكُ بِهٖ شَيْئًا، اَللّٰهُ اَكْبَرُ، اَللّٰهُ اَكْبَرُ، اَللّٰهُ اَكْبَرُ ، اَللّٰهُ اَكْبَرُ ، وَ اَعَزُّ وَ اَجَلُّ مِمَّا اَخَافُ وَ اَحْذَرُ. اَسْاَلُكَ اللّٰهُمَّ بِخَيْرِكَ مِنْ خَيْرِكَ الَّذِىْ لَا يُعْطِيْهِ غَيْرُكَ، عَزَّ جَارُكَ وَ جَلَّ ثَنَاؤُكَ وَلَا اِلٰهَ غَيْرُكَ. اَللّٰهُمَّ اِنِّىْ اَعُوْذُ بِكَ مِنْ شَرِّ نَفْسِىْ، وَ مِنْ شَرِّ كُلِّ سُلْطَانٍ وَّ مِنْ شَرِّ كُلِّ شَيْطَانٍ مَّرِيْدٍ، وَ مِنْ شَرِّ كُلِّ جَبَّارٍ عَنِيْدٍ، وَ مِنْ شَرِّ كُلِّ قَضَاءِ سُوْءٍ ، وَ مِنْ شَرِّ كُلِّ دَابَّةٍ اَنْتَ اٰخِذٌ بِنَاصِيَتِهَا، اِنَّ رَبِّیْ عَلٰى صِرَاطٍ مُّسْتَقِيْمٍ، وَ اَنْتَ عَلٰى كُلِّ شَیْءٍ حَفِیْظٌ
﴿اِنَّ وَلِيِّیَ اللّٰهُ الَّذِیْ نَزَّلَ الْكِتَابَ وَهُوَ يَتَوَلَّى الصَّالِحِيْنَ﴾
اَللّٰهُمَّ اِنِّىْ اَسْتَجِيْرُ بِكَ، وَ اَحْتَجِبُ بِكَ مِنْ كُلِّ شَیْءٍ خَلَقْتَهٗ، وَ اَحْتَرِسُ بِكَ مِنْ جَمِيْعِ خَلْقِكَ، وَ كُلِّ مَا ذَرَاْتَ وَبَرَاْتَ وَ اَحْتَرِسُ بِكَ مِنْهُمْ، وَاُفَوِّضُ اَمْرِىْ اِلَيْكَ، وَ اُقَدِّمُ بَيْنَ يَدَیَّ فِیْ يَوْمِیْ هٰذَا، وَ لَيْلَتِىْ هٰذِهٖ، وَ سَاعَتِىْ هٰذِهٖ، وَ شَهْرِىْ هٰذَا.
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
قُلْ هُوَ اللّٰهُ اَحَدٌ، اَللّٰهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُوْلَدْ، وَلَمْ يَكُنْ لَّهٗ كُفُوًا اَحَدٌ﴾عَنْ اَمَامِىْ
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
﴿قُلْ هُوَ اللّٰهُ اَحَدٌ، اَللّٰهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَّهٗ كُفُوًا اَحَدٌ﴾مِنْ خَلْفِیْ
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
قُلْ هُوَ اللّٰهُ اَحَدٌ، اَللّٰهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَّهٗ كُفُوًا اَحَدٌ﴾عَنْ يَّمِيْنِىْ
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
قُلْ هُوَ اللّٰهُ اَحَدٌ، اَللّٰهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَّهٗ كُفُوًا اَحَدٌ﴾عَنْ شِمَالِىْ
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
قُلْ هُوَ اللّٰهُ اَحَدٌ، اَللّٰهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَّهٗ كُفُوًا اَحَدٌ﴾مِنْ فَوْقِیْ
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
قُلْ هُوَ اللّٰهُ اَحَدٌ، اَللّٰهُ الصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُنْ لَّهٗ كُفُوًا اَحَدٌ﴾مِنْ تَحْتِیْ
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
اَللّٰهُ لَا اِلٰهَ اِلَّا هُوَ الْحَیُّ الْقَيُّوْمُ، لَا تَاْخُذُهٗ سِنَةٌ وَّلَا نَوْمٌ، لَهٗ مَا فِی السَّمٰوَاتِ وَمَا فِی الْاَرْضِ، مَنْ ذَا الَّذِیْ يَشْفَعُ عِنْدَهٗ اِلَّا بِاِذْنِهٖ، يَعْلَمُ مَا بَيْنَ اَيْدِيْهِمْ وَمَا خَلْفَهُمْ، وَلَايُحِيْطُوْنَ بِشَیْءٍ مِّنْ عِلْمِهٖ اِلَّا بِمَا شَاءَ، وَسِعَ كُرْسِيُّهُ السَّمٰوَاتِ وَالْاَرْضَ وَلَا يَئُوْدُهٗ حِفْظُهُمَا، وَهُوَ الْعَلِیُّ الْعَظِيْمُ.
بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
شَهِدَ اللّٰهُ اَنَّهٗ لَا اِلٰهَ اِلَّا هُوَ وَالْمَلَآئِكَةُ وَاُولُو الْعِلْمِ قَائِمًا بِالْقِسْطِ، لَا اِلٰهَ اِلَّا هُوَ الْعَزِيْزُ الْحَكِيْمُ.(7 بار)
وَنَحْنُ عَلىٰ مَا قَالَ رَبُّنَا مِنَ الشَّاهِدِيْنَ﴿فَاِنْ تَوَلَّوْا فَقُلْ حَسْبِیَ اللّٰهُ لَا اِلٰهَ اِلَّا هُوَ، عَلَيْهِ تَوَكَّلْتُ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيْمِ﴾ (7 بار)`
    },

    
  ];

  return (
    <div className="container py-4 py-md-5">
      <div className="row justify-content-center px-2">
        {duaList.map((dua, index) => (
          
          /* ✅ FIX 1: Max-Width constraint. It will look like a phone screen even on PC */
          <div key={index} className="col-12 col-md-8 col-lg-6 mb-5" style={{ maxWidth: '650px' }}>
            
            <div className="card shadow-lg border-0 overflow-hidden" style={{ borderRadius: "24px", backgroundColor: "#faf9f6" }}>
              
              {/* --- HEADER --- */}
              <div className="text-center p-4" style={{ backgroundColor: "#004d40" }}>
                <h2 
                  dir="rtl" 
                  style={{ 
                    fontFamily: "JameelNooriNastaleeq", 
                    fontSize: "2.2rem", 
                    color: "#FFD700", 
                    marginBottom: "5px"
                  }}
                >
                  {dua.title}
                </h2>
                <h3 
                  dir="rtl" 
                  style={{ 
                    fontFamily: "JameelNooriNastaleeq", 
                    fontSize: "1.4rem", 
                    color: "#e0e0e0", 
                    margin: "0" 
                  }}
                >
                  {dua.subtitle}
                </h3>
              </div>

              {/* --- BODY --- */}
              <div className="p-3 p-md-5">
                
                <h3
                  className="text-center mb-4"
                  dir="rtl"
                  style={{
                    fontFamily: "AlQalam",
                    fontSize: "2rem",
                    color: "#1a472a",
                    borderBottom: "2px solid #e9ecef",
                    paddingBottom: "15px"
                  }}
                >
                  بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ
                </h3>

                {/* ✅ FIX 2: Smart Paragraph Renderer */}
                <div dir="rtl">
                  {dua.arabic.split('\n').map((line, i) => {
                    const trimmedLine = line.trim();
                    if (!trimmedLine) return null; // Skip empty lines

                    return (
                      <p 
                        key={i}
                        style={{
                          fontFamily: "AlQalam",
                          fontSize: "1.6rem",
                          lineHeight: "2.4", // Perfect reading height
                          color: "#222",
                          textAlign: "right", // ✅ FIX 3: Strict Right Alignment
                          marginBottom: "16px", // Adds space between paragraphs
                          wordSpacing: "2px"
                        }}
                      >
                        {trimmedLine}
                      </p>
                    );
                  })}
                </div>

              </div>
            </div>
          </div>

        ))}
      </div>
    </div>
  );
};

export default Duas;